import { Button, List, ListProps, ListItem } from "@mui/material";
import {
  ArrowDropDown as DownIcon,
  ArrowDropUp as UpIcon
} from "@mui/icons-material";
import { useEffect, useState } from "react";

type LimittedListProps<T> = {
  keyPrefix: string
  list: T[]
  count: number
  record: (data: T, i: number) => React.JSX.Element
} & ListProps
export const LimittedList = <T,>({
  keyPrefix,
  list,
  count,
  record,
  ...others
}: LimittedListProps<T>) => {
  const [allShow, setAllShow] = useState<boolean>(false)
  useEffect(() => setAllShow(false), [list])
  return (
    <List disablePadding sx={{ paddingX: 0, paddingTop: 0, paddingBottom: list.length > count ? 0 : 1 }} {...others}>
      {(allShow !== false ? list : list.slice(0, count)).map((r, i) => (
        <ListItem key={`${keyPrefix}-${i}`} disablePadding>
          {record(r, i)}
        </ListItem>
      ))}
      {list.length > count && (
        <ListItem sx={{ padding: 1 }}>
          <Button
            size='small'
            fullWidth
            startIcon={allShow ? <UpIcon/> : <DownIcon/>}
            style={{ whiteSpace: 'nowrap' }}
            onClick={() => setAllShow(allShow ? false : true)}
          >
            {allShow ? "閉じる" : `すべて表示（${list.length} 件）`}
          </Button>
        </ListItem>
      )}
    </List>
  )
}